import {
  FetchGuestNotificationsQuery,
  FetchHostNotificationsQuery,
} from '@website/types/graphqlOperations';
import { useMemo } from 'react';
import { Alert, ListGroup } from 'react-bootstrap';
import IndividualNotification from './IndividualNotification';
import groupNotifications from './utils/groupNotifications';

export type Notification =
  | FetchHostNotificationsQuery['hostByURL']['notifications']['items'][0]
  | FetchGuestNotificationsQuery['user']['notifications']['items'][0];

type Props = {
  notifications: Notification[];
};

export default function Notifications({ notifications }: Props) {
  const groupedNotifications = useMemo(
    () => groupNotifications(notifications),
    [notifications],
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-end mb-3 mt-3">
        <h1 className="hero-heading mb-0">Notifications</h1>
      </div>
      {notifications.length === 0 ? (
        <Alert variant="info">
          <p>
            <strong>You don't have any notifications yet.</strong>
          </p>
        </Alert>
      ) : (
        <ListGroup as="div" className="mb-5">
          {Object.entries(groupedNotifications).map(([key, notification]) => (
            <IndividualNotification key={key} notifications={notification} />
          ))}
        </ListGroup>
      )}
    </>
  );
}
